import api from 'core/util/api';
import type { Query } from '@kentik/ui-shared/query/query.types';
import type { PendingUdeQuery } from 'app/views/boards/panels/ude/form.types';
import { action, observable } from 'mobx';

class UdeStore {
  @observable flowVariant = 'a';

  ude = {
    id: '',
    name: '',
    description: '',
    createdAt: '',
    updatedAt: ''
  };

  pendingQuery: PendingUdeQuery | null = null;

  @action
  setFlowVariant(variant: string) {
    this.flowVariant = variant;
  }

  runQuery(query: Query) {
    return api.post('/api/ui/ude/query', { data: { query } });
  }

  /** Stash a query + chart settings for navigation to the UDE page. */
  setPendingQuery(pending: PendingUdeQuery) {
    this.pendingQuery = pending;
  }

  /** One-shot read of the stashed pending query. Returns and clears it. */
  consumePendingQuery(): PendingUdeQuery | null {
    const pending = this.pendingQuery;
    this.pendingQuery = null;
    return pending;
  }
}

export default new UdeStore();
